<template>
  <div class="justify-center layout px-0">
    <v-btn flat icon @click="update ">
      <v-icon>edit</v-icon>
    </v-btn>
    <v-btn flat icon color="red" @click="remove">
      <v-icon>delete</v-icon>
    </v-btn>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  methods: {
    remove() {
      this.params.onDelete(this.params.data)
    },
    update() {
      this.params.onUpdate(this.params.data)
    }
    // setHardwareItem() {
    //   let hardware = this.params.data
    //   hardware.type = 'hardware'
    //   this.params.clicked(hardware)
    // },
  }
})
</script>
